import React, {useEffect, useState} from 'react';
import {Formik, Form, Field} from 'formik';
import {useUser} from "../../../contexts/UserContext";
import form_styles from "../../Form/Form.module.css";
import FieldCustom from "../../Field/FieldCustom";
import styles from "../../../pages/Admin/Admin.module.css";
import AxiosConfig from "../../../services/AxiosConfig";
import FieldUpload from "../../Field/FieldUpload";
import modalSuccess from "../../Modal/ModalSuccess";
import {useModal} from "../../../contexts/ModalContext";
import {Link, useNavigate} from "react-router-dom";
import TitleSecondary from "../../Title/TitleSecondary";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";
import FieldRadio from "../../Field/FieldRadio";
import {getContratDetailsStatusIcon} from "../../../services/ActivitesService";
import loginForm from "../../Login/LoginForm";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong, faBuilding} from "@fortawesome/free-solid-svg-icons";
import {getUtilisateurRoleIcon} from "../../../services/UserService";
import BtnSave from "../../Button/BtnSave";
import FieldCheckbox from "../../Field/FieldCheckbox";
import DateService from "../../../services/DateService";

function ContratCreation({contrat = null, entreprise = null, onSaved = () => {}}) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [inputs, setInputs] = useState([]);
    const [initialValues, setInitialValues] = useState({
        referentId: '',
        status: '',
        debut: '',
        fin: '',
        max_participations_actif: false,
        max_participations: '',
        label: '',
    });
    const [referents, setReferents] = useState([]);
    let navigate = useNavigate();

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    useEffect(() => {
        if (!entreprise || !entreprise.id) return;

        const fetchThat = async () => {
            const response = await AxiosConfig.get(`/admin/entreprises/${entreprise.id}/referents`);
            setReferents(response.data.myReferents);
        }
        fetchThat();
    }, [contrat, entreprise]);


    const handleSubmit = async (values, {setSubmitting}) => {
        values.contrat_id = contrat?.id || null;

        try {
            const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/creation`, values);
            handleSuccess(response.data.message);
            onSaved();
            navigate(`/admin/entreprises/${entreprise.id}/contrats/${response.data.id}`);
        } catch (error) {
            console.error(error);
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        if (!contrat || !contrat.id) return;
        setInitialValues({
            referentId: String(contrat.referent?.id ?? ''),
            status:  String(contrat.status || ''),
            debut: DateService.formatDateWithoutTime(contrat.date_start) || '',
            fin: DateService.formatDateWithoutTime(contrat.date_end) || '',
            max_participations_actif: !!contrat.max_participations,
            max_participations: contrat.max_participations || '',
            label: contrat.label ?? '',
        });
    }, [contrat]);

    return (
        <div style={{margin: '0 0 50px 0'}}  className={styles.viewBloc}>
            <TitleSecondary text={contrat ? "Modification" : "Nouveau contrat"}/>
            <div className={styles.containerColumns}>
                <div className={styles.formBloc}>
                    <h3>{entreprise?.nom} </h3>
                    <span style={{fontSize: "0.9em", display: "flex", flexDirection: "row", gap: "4px"}}>
                        <FontAwesomeIcon icon={faBuilding}/>
                        {entreprise?.addr} {entreprise?.cp} {entreprise?.ville}
                    </span>
                    <span style={{fontSize: "0.9em", display: "flex", flexDirection: "row", gap: "4px"}}>
                        {getUtilisateurRoleIcon("ROLE_REFERENT")}
                        {contrat?.referent?.prenom ? contrat?.referent?.prenom + " " + contrat?.referent?.nom : "Pas de référent enregistré"}
                    </span>
                </div>
            </div>

                {Object.keys(initialValues).length > 0 ? (
                    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
                        {({isSubmitting, setFieldValue, values}) => {
                            return (
                                <Form>
                                    <div className={styles.containerColumns}>
                                        <div className={styles.formBloc}>
                                            <h3>Référent </h3>
                                            <div style={{display: "flex", flexDirection: "column"}}>
                                                {referents.length > 0 ?
                                                    (referents.map((referent, index) => (
                                                            <FieldRadio key={index}
                                                                        label={`${referent.prenom} ${referent.nom}`}
                                                                        name={"referentId"} value={String(referent.id)}/>
                                                        )
                                                    ))
                                                    :
                                                    <p>Pas de référents pour cette entreprise</p>
                                                }
                                            </div>

                                            <Link
                                                to={`/admin/utilisateurs?mode=creation&entreprise=${entreprise.id}&role=ROLE_REFERENT`}
                                                className={styles.btnAdd}>
                                                <AjouterIcone/>
                                                Ajouter un référent
                                            </Link>
                                        </div>

                                        <div className={styles.formBloc}>
                                            <div style={{display: "flex", flexDirection: "column"}}>
                                                <h3>Statut</h3>
                                                <FieldRadio label={"Actif"} name="status" value={"1"}/>
                                                <FieldRadio label={"Résiliation"} name="status" value={"2"}/>
                                                <FieldRadio label={"Résilié"} name="status" value={"3"}/>
                                                <FieldRadio label={"Prospection"} name="status" value={"0"}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={styles.formBloc}>
                                        <h3>Dates</h3>
                                        <div style={{display: "flex", flexDirection: "row", gap: "16px"}}>
                                            <FieldCustom type={"date"} name={"debut"} label={"Début"} placeholder={""}/>
                                            <FieldCustom type={"date"} name={"fin"} label={"Fin"} placeholder={""}/>
                                        </div>
                                    </div>

                                    <div className={styles.formBloc}>
                                        <h3 style={{ margin: 0}}>Label</h3>
                                        <div style={{display: "flex", flexDirection: "column", gap: "1px"}}>
                                            <span style={{ fontSize: "12px", color: "#222", fontStyle: "italic" }}>(facultatif)</span>
                                            <FieldCustom type={"text"} name={"label"} placeholder={"Cours collectif en entreprise"}/>
                                        </div>
                                    </div>

                                    <div className={styles.formBloc} style={{ gap: 0 }}>
                                        <h3 style={{ marginBottom: 0 }}>Options</h3>
                                        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>

                                            <div style={{marginTop: "16px"}}>
                                                <FieldCheckbox name={"max_participations_actif"} label={"Activer un nombre de participations max par semaine"}/>
                                            </div>

                                            {values.max_participations_actif && (
                                                <FieldCustom type={"number"} name={"max_participations"} label={""} placeholder={""} />
                                            )}
                                        </div>
                                    </div>

                                    <div className={"barre_btn"}>
                                        <button type={"button"} onClick={() => {
                                            navigate(-1)
                                        }} className={"btn btn_danger"}><AnnulerIcone/>Annuler
                                        </button>
                                        <BtnSave isSubmitting={isSubmitting}/>
                                    </div>
                                </Form>
                            )
                        }}
                    </Formik>
                ) : (<p>Chargement...</p>)}
        </div>);
}

export default ContratCreation;